import { useEffect, useState } from 'react';
import { loadSkillSynonymData } from '../utils/cv-check/job-match';
import { onSkillSynonymsLoaded, skillSynonymsLoaded } from '../utils/cv-check/skill-synonyms';

/**
 * Loads the cross-language skill synonyms (TEC-711) when `enabled` (the visitor has a CV) and
 * returns true once they're in, so a memoised match can list it as a dependency and re-run with
 * translations counted. Visitors without a CV never download the data.
 */
export function useSkillSynonymsReady(enabled: boolean): boolean {
  const [ready, setReady] = useState(skillSynonymsLoaded);
  useEffect(() => {
    if (!enabled || ready) return;
    const off = onSkillSynonymsLoaded(() => setReady(true));
    void loadSkillSynonymData();
    if (skillSynonymsLoaded()) setReady(true);
    return off;
  }, [enabled, ready]);
  return ready;
}
